'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('react');
const styled = require('styled-components');
const styled__default = _interopDefault(styled);

var ImageWrapper = styled__default.div.withConfig({
  displayName: "imagestyle__ImageWrapper",
  componentId: "sc-xw1tzz-0"
})(["display:inline-block;width:", ";height:", ";border-radius:", ";-webkit-border-radius:", ";overflow:", ";border:", ";position:relative;", ""], function (_ref) {
  var w = _ref.w;
  return w;
}, function (_ref2) {
  var h = _ref2.h;
  return h;
}, function (_ref3) {
  var rounded = _ref3.rounded,
      borderRadius = _ref3.borderRadius;
  return rounded ? '50%' : borderRadius ? borderRadius : '';
}, function (_ref4) {
  var rounded = _ref4.rounded,
      borderRadius = _ref4.borderRadius;
  return rounded ? '50%' : borderRadius ? borderRadius : '';
}, function (_ref5) {
  var rounded = _ref5.rounded,
      borderRadius = _ref5.borderRadius;
  return rounded || borderRadius ? 'hidden' : '';
}, function (_ref6) {
  var rounded = _ref6.rounded,
      border = _ref6.border;
  return rounded && border ? border : '';
}, function (_ref7) {
  var visible = _ref7.visible;
  return !visible && 'visibility: hidden;';
});
var Img = styled__default.img.withConfig({
  displayName: "imagestyle__Img",
  componentId: "sc-xw1tzz-1"
})(["box-sizing:border-box;padding:", ";background-color:", ";&:-moz-loading{color:", ";}border-radius:", ";-webkit-border-radius:", ";"], function (_ref8) {
  var padding = _ref8.padding;
  return padding;
}, function (_ref9) {
  var backgroundColor = _ref9.backgroundColor;
  return backgroundColor;
}, function (_ref10) {
  var backgroundColor = _ref10.backgroundColor;
  return backgroundColor;
}, function (_ref11) {
  var rounded = _ref11.rounded,
      borderRadius = _ref11.borderRadius;
  return rounded ? '50%' : borderRadius ? borderRadius : '';
}, function (_ref12) {
  var rounded = _ref12.rounded,
      borderRadius = _ref12.borderRadius;
  return rounded ? '50%' : borderRadius ? borderRadius : '';
}); // Construct the styled placeholder using several variables + backups

var retrieveHeightFromRatio = function retrieveHeightFromRatio(placeholderHeight, height, width) {
  var ratio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '1:1';
  var h = placeholderHeight || height;

  if (typeof h !== 'undefined') {
    return h;
  }

  var ratioArr = ratio.split(':');
  var rWidth = parseFloat(ratioArr[0]);
  var rHeight = parseFloat(ratioArr[1]);

  if (typeof width === 'string') {
    // Since we're probably dealing with 'px' or '%' in the string, this separates
    // the number from the unit and stores both for use later on.
    var parsedWidth = width.replace(/\'/g, '').split(/(\d+)/);
    var numValue = parseFloat(parsedWidth[1]);
    var unit = parsedWidth[2];
    return "".concat(numValue * rHeight / rWidth).concat(unit || 'px');
  } else {
    return width * rHeight / rWidth;
  }
};
var Placeholder = styled__default.div.withConfig({
  displayName: "imagestyle__Placeholder",
  componentId: "sc-xw1tzz-3"
})(["height:", ";width:", ";background-color:", ";border-radius:8px;border:", ";"], function (_ref13) {
  var placeholderHeight = _ref13.placeholderHeight,
      h = _ref13.h,
      w = _ref13.w,
      ratio = _ref13.ratio;
  return retrieveHeightFromRatio(placeholderHeight, h, w, ratio);
}, function (_ref14) {
  var placeholderWidth = _ref14.placeholderWidth,
      w = _ref14.w;
  return placeholderWidth || w;
}, function (_ref15) {
  var backgroundColor = _ref15.backgroundColor;
  return backgroundColor;
}, function (_ref16) {
  var border = _ref16.border;
  return border;
});

exports.ImageWrapper = ImageWrapper;
exports.Img = Img;
exports.Placeholder = Placeholder;
